export default {
  main: '#04104a',
  secondary: '#da4f9a',
  contrastingColor: '#ffffff',
  priceColor: '#EBC15B',
  entryBackground: '#04104a',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
